import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { TimetrackingComponent } from "./timetracking/timetracking.component";
import { AuthGuard } from "./shared/security/auth.guard";
import { ModalContainerComponent } from "./modal-container/modal-container.component";
import { TimeAddComponent } from "./timetracking/time-add/time-add.component";
import { TimeListComponent } from "./timetracking/time-list/time-list.component";
import { TimeEditComponent } from "./timetracking/time-edit/time-edit.component";
import { TimeDeleteComponent } from "./timetracking/time-delete/time-delete.component";
import { OrgChartComponent } from "./org-chart/org-chart.component";
import { PtoModule } from "./pto/pto.module";
import {ErrorPageComponent} from "./error/error/error-page.component";

const routes: Routes = [
  {
    path: "timetracking",
    component: TimetrackingComponent,
    canActivate: [AuthGuard],
  },
  // lazy loading things that i think will be less used by the majority
  {
    path: "reports",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
    data: { }
  },
  {
    path: "periods",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./time-periods/time-periods.module").then(
        (m) => m.TimePeriodsModule
      ),
    data: { roles: ["Admin"] }
  },
  {
    path: "pto",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pto/pto.module").then((m) => m.PtoModule
      ),
    data: { roles: ["Admin"], exemptionPaths: [""] }
  },
  {
    path: "holidays",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./holiday/holiday.module").then((m) => m.HolidaysModule
      ),
    data: { roles: ["Admin"], exemptionPaths: [""] }
  },
  {
    path: "org",
    canActivate: [AuthGuard],
    component: OrgChartComponent,
    data: { }
  },
  {
    path: "admin",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./admin/admin.module").then((m) => m.AdminModule),
    data: { roles: ["Admin"] }
  },
  {
    path: "modal",
    canActivate: [AuthGuard],
    outlet: "modal",
    component: ModalContainerComponent,
    children: [
      {
        path: "time",
        component: TimeListComponent,
      },
      {
        path: "time/add",
        component: TimeAddComponent,
      },
      {
        path: "time/edit/:entryId",
        component: TimeEditComponent,
      },
      {
        path: "time/delete/:entryId",
        component: TimeDeleteComponent,
      },
    ],
  },
  { path: 'error', component: ErrorPageComponent },
  { path: "**", redirectTo: "/timetracking", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
